import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="7mm"
    height={12.841}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 92679 44982"
    {...props}
  >
    <defs>
      <style>
        {/* {".str1{stroke:#2b2a29;stroke-width:2335.51}.fil0{fill:none}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M19144 40018c238 364 377 798 377 1294 0 1303-1042 2346-2317 2346h-6285c-1274 0-2317-1043-2317-2346 0-496 139-930 379-1294H6825c-3025 0-5501-2475-5501-5502V6826c0-3026 2476-5502 5501-5502h79028c3025 0 5502 2476 5502 5502v27690c0 2999-2435 5459-5424 5502 220 353 347 771 347 1245 0 1305-1042 2348-2316 2348h-6285c-1275 0-2318-1043-2318-2348 0-474 128-892 348-1245H19144zm53845-25606c3266 0 5914 2625 5914 5862 0 3239-2648 5863-5914 5863-3267 0-5914-2624-5914-5863 0-3237 2647-5862 5914-5862zm1-6855c7085 0 12828 5695 12828 12717 0 7025-5743 12718-12828 12718-7087 0-12831-5693-12831-12718 0-7022 5744-12717 12831-12717z"
        style={{
          // stroke: "#2b2a29",
          strokeWidth: 2647.97,
        }}
        className="fill-none stroke1"
      />
      <rect
        width={5296}
        height={26480}
        x={7944}
        y={6604}
        className="fill-none stroke1"
        style={{
          strokeWidth: 2335.51,
        }}
        rx={45498}
        ry={52125}
      />
      <rect
        width={5296}
        height={26480}
        x={19860}
        y={6604}
        className="fill-none stroke1"
        style={{
          strokeWidth: 2335.51,
        }}
        rx={45498}
        ry={52125}
      />
      <rect
        width={5296}
        height={26480}
        x={31776}
        y={6604}
        className="fill-none stroke1"
        style={{
          strokeWidth: 2335.51,
        }}
        rx={45498}
        ry={52125}
      />
    </g>
  </svg>
);
export default SvgComponent;
